import * as React from "react";

import Tabs from "src/components/common/Tabs";
import ClientAppConstants from "src/common/Constants";

interface IProps {
	className?: string;
	location?: any;
	organizationId: string;
}

const OrganizationTabs: React.FC<IProps> = (props) => {
	const tabs = createTabs(props.organizationId);
	return (
		<Tabs className={props.className} tabs={tabs} location={props.location} />
	);
};

const createTabs = (organizationId: string) => {
	if (organizationId === "0") {
		return [
			{
				to: `/admin/organizations/${organizationId}`,
				label: "Add Organization",
			},
		];
	}

	if (organizationId === ClientAppConstants.DefaultOrgId.toString()) {
		return [
			{
				to: `/admin/organizations/${organizationId}`,
				label: "Default Organization Details",
			},
			{
				to: `/admin/organizations/${organizationId}/roles`,
				label: "Roles",
			},
			{
				to: `/admin/organizations/${organizationId}/users`,
				label: "Users",
			},
		];
	} else {
		return [
			{
				to: `/admin/organizations/${organizationId}`,
				label: "Settings",
			},
			{
				to: `/admin/organizations/${organizationId}/locations`,
				label: "Locations",
			},
			{
				to: `/admin/organizations/${organizationId}/datasets`,
				label: "Datasets",
			},
			{
				to: `/admin/organizations/${organizationId}/roles`,
				label: "Roles",
			},
			{
				to: `/admin/organizations/${organizationId}/users`,
				label: "Users",
			},
			{
				to: `/admin/organizations/${organizationId}/report-settings`,
				label: "Branding",
			},
			// {
			// 	to: `/admin/organizations/${organizationId}/fleet-errors`,
			// 	label: 'Fleet-errors'
			// },
			{
				to: `/admin/organizations/${organizationId}/custom-fields`,
				label: "Custom fields",
			},
			{
				to: `/admin/organizations/${organizationId}/training-summary`,
				label: "Training Summary",
			},
		];
	}
};

export default OrganizationTabs;
